module.exports = __webpack_public_path__ + "./docs/img/voximplant_docs_white.b1490210622308e0922e10712f846095.svg";